document.addEventListener('DOMContentLoaded', function() {
  
  const hybridsBtn = document.getElementById("hybridsBtn");
  const hybridsCancelButton = document.getElementById("hybridsCancelBtn");
  const hybridsDialog = document.getElementById("hybridsDialog");


  hybridsBtn?.addEventListener("click", () => {
    hybridsDialog.showModal();
    hybridsDialog.setAttribute('aria-modal', true);
  });

  hybridsCancelButton?.addEventListener("click", () => {
    hybridsDialog.close();
    hybridsDialog.setAttribute('aria-modal', false);
  });

  hybridsDialog?.addEventListener("click", (event) => {
    if (event.target === hybridsDialog) {
      hybridsDialog.close();
      hybridsDialog.setAttribute('aria-modal', false);
    }
  });

  hybridsCancelButton?.addEventListener('keydown', (e) =>{
    if(e.code == 'Space' || e.key == 'Enter' || e.key == 'Escape'){
      e.preventDefault();
      e.stopPropagation();
      hybridsDialog.close();
      hybridsDialog.setAttribute('aria-modal', false);
    }
  })

  hybridsDialog?.addEventListener('keydown', trapFocus);

  function trapFocus(event) {
    let focusableElements = hybridsDialog.querySelectorAll('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    let firstFocusableElement = focusableElements[0];
    let lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (event.key === 'Tab') {
      if (event.shiftKey) { // Shift + Tab
        if (document.activeElement === firstFocusableElement) {
          event.preventDefault();
          lastFocusableElement.focus();
        }
      } else { // Tab
        if (document.activeElement === lastFocusableElement) {
          event.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }
  }

  document.querySelectorAll('.product__selectors .swatch__label').forEach(item => {
    item.addEventListener('keydown', (e) => {
      switch(e.key) {
          case 'Enter':
            e.preventDefault();
            item.closest('.swatch__button').querySelector('.swatch__input').click();
          break;
      }
    });
  })

  document.querySelectorAll('.zin-radio__button').forEach(item => {
    item.querySelector('.zin-radio__label').addEventListener('keydown', (e) => {
      switch(e.key) {
          case 'Enter':
            e.preventDefault();
            item.querySelector('.radio__input').click();
          break;
      }
    });
  })

  document.querySelectorAll('fieldset.radio__fieldset').forEach(function (fs) {
    const selectedText = fs.querySelector('[data-selected-text]');
    if (!selectedText) return;

    fs.addEventListener('change', function (e) {
      const input = e.target;
      if (!input || !input.matches('input[type="radio"][data-single-option-selector]')) return;

      const label = fs.querySelector('label[for="' + input.id + '"]');
      const text = (label && label.getAttribute('data-swatch')) || input.value;
      selectedText.textContent = text;
    });
  });


  const sizeGuideBtn = document.getElementById("sizeGuideBtn");
  const cancelButton = document.getElementById("sizeGuideCancelBtn");
  const sizeModal = document.getElementById("sizeGuideDialog");

  sizeGuideBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    sizeModal.setAttribute('aria-modal', true);
    sizeModal.showModal();
    
  });

  cancelButton?.addEventListener("click", () => {
    sizeModal.close();
    sizeModal.setAttribute('aria-modal', false);
  });

  cancelButton?.addEventListener('keydown', (e) =>{
    if(e.code == 'Space' || e.key == 'Enter' || e.key == 'Escape'){
      e.preventDefault();
      e.stopPropagation();
      sizeModal.setAttribute('aria-modal', false);
      sizeModal.close();
    }
  })

  sizeModal?.addEventListener("click", (event) => {
    if (event.target === sizeModal) {
      sizeModal.setAttribute('aria-modal', false);
      sizeModal.close();
    }
  });

  dialog?.addEventListener("click", (event) => {
    if (event.target === dialog) {
        dialog.close();
    }
  })

  sizeModal?.addEventListener('keydown', sizetrapFocus);

  function sizetrapFocus(event) {
    let focusableElements = sizeModal.querySelectorAll('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    let firstFocusableElement = focusableElements[0];
    let lastFocusableElement = focusableElements[focusableElements.length - 1];
    if (event.key === 'Tab') {
      if (event.shiftKey) { // Shift + Tab
        if (document.activeElement === firstFocusableElement) {
          event.preventDefault();
          lastFocusableElement.focus();
        }
      } else { // Tab
        if (document.activeElement === lastFocusableElement) {
          event.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }
  }
  // PRODUCT PAGE PRICING - MATERIAL RADIO BUTTONS
  const memoryFoam = document.querySelector('.zin-memory-foam');
  const hybrid = document.querySelector('.zin-hybrid');

  const memoryFoamMobile = document.querySelector('.zin-memory-foam-mobile');
  const hybridMobile = document.querySelector('.zin-hybrid-mobile');

  const materialMemoryFoam1 = document.querySelector('.zin-material-memory-foam-1');
  const materialMemoryFoam2 = document.querySelector('.zin-material-memory-foam-2');

  const materialHybrid1 = document.querySelector('.zin-material-hybrid-1');
  const materialHybrid2 = document.querySelector('.zin-material-hybrid-2');

  const memoryFoamRadioButton = document.querySelector('.zin-material-radio-1 .zin-material-label');
  const hybridRadioButton = document.querySelector('.zin-material-radio-2 .zin-material-label');

  memoryFoamRadioButton?.addEventListener('click', () => {
    memoryFoam.classList.remove('hidden');
    memoryFoamMobile.classList.remove('hidden');

    hybrid.classList.add('hidden');
    hybridMobile.classList.add('hidden');

    materialMemoryFoam1.classList.remove('hidden');
    materialHybrid1.classList.add('hidden');
    materialMemoryFoam2.classList.remove('hidden');
    materialHybrid2.classList.add('hidden');

  });

  hybridRadioButton?.addEventListener('click', () => {
    memoryFoam.classList.add('hidden');
    memoryFoamMobile.classList.add('hidden');

    hybrid.classList.remove('hidden');
    hybridMobile.classList.remove('hidden');

    materialMemoryFoam1.classList.add('hidden');
    materialHybrid1.classList.remove('hidden');
    materialMemoryFoam2.classList.add('hidden');
    materialHybrid2.classList.remove('hidden');
  });
  setTimeout(function() {
    var currentURL = window.location.href;
    let checkZinus = document.querySelector('.zinus-original');
    if(checkZinus && currentURL.includes('40316113')){
      document.querySelector('.ultra-cooling-green-tea').classList.add('hidden');
      document.querySelector('#zinusOriginalRadio').classList.remove('opacity');
      document.querySelector('.cooling-green-tea').classList.remove('opacity');
    }else if(checkZinus && currentURL.includes('4032118')){
      document.querySelector('#zinusOriginalRadio').classList.add('hidden');
      document.querySelector('.ultra-cooling-green-tea').classList.remove('opacity');
      document.querySelector('.cooling-green-tea').classList.remove('opacity');
      document.querySelector('.cooling-green-tea .most_popular').classList.add('hidden');
      document.querySelector('.cooling-green-tea .compare_at_price').classList.add('hidden');
    }else if(checkZinus && currentURL.includes('4040070')){
      document.querySelector('.pdp-variant-1-text').classList.add('hidden');
      document.querySelectorAll('.zin-radio__button').forEach(item=>{
        item.classList.add('hidden');
      })
      document.querySelectorAll('.zin-radio__button').forEach(item=>{
        item.classList.remove('opacity');
      })
    }
  }, 1000);
  function convertDiscountDivToH2() {
    const productBlocks = document.querySelectorAll('.product__block');
    let found = false;
    
    if (productBlocks.length > 0) {
      productBlocks.forEach(block => {
        const allDivs = block.querySelectorAll('div');        
        allDivs.forEach(div => {
          if (!div.parentNode || div.tagName === 'H2' || div.hasAttribute('data-converted-to-h2')) return;
          
          const styleAttr = div.getAttribute('style') || '';
          if (styleAttr.includes('color') && 
              (styleAttr.includes('#FFFFFF') || styleAttr.includes('#ffffff')) &&
              styleAttr.includes('font-size') &&
              styleAttr.includes('15px') &&
              styleAttr.includes('font-weight') &&
              styleAttr.includes('500')) {
            
            const h2 = document.createElement('h2');
            div.setAttribute('data-converted-to-h2', 'true');
            
            Array.from(div.attributes).forEach(attr => {
              h2.setAttribute(attr.name, attr.value);
            });
            
            h2.innerHTML = div.innerHTML;
            div.parentNode.replaceChild(h2, div);
            found = true;
          }
        });
      });
    }
    if (!found) {
      const allDivs = document.querySelectorAll('div');      
      allDivs.forEach(div => {
        if (!div.parentNode || div.tagName === 'H2' || div.hasAttribute('data-converted-to-h2')) return;
        
        const styleAttr = div.getAttribute('style') || '';
        // Convert div to h2 if it has the discount message styling pattern
        if (styleAttr.includes('color') && 
            (styleAttr.includes('#FFFFFF') || styleAttr.includes('#ffffff')) &&
            styleAttr.includes('font-size') &&
            styleAttr.includes('15px') &&
            styleAttr.includes('font-weight') &&
            styleAttr.includes('500')) {
          const h2 = document.createElement('h2');
          div.setAttribute('data-converted-to-h2', 'true');            
          Array.from(div.attributes).forEach(attr => {
            h2.setAttribute(attr.name, attr.value);
          });            
          h2.innerHTML = div.innerHTML;
          div.parentNode.replaceChild(h2, div);
        }
      });
    }
  }
  const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        shouldCheck = true;
      }
    });
    if (shouldCheck) {
    }
  });
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  let tablists = document.querySelectorAll('.pdp-tabs');

  tablists.forEach((tablist) => {
    let tabs = tablist.querySelectorAll('.pdp-tablinks:not([disabled="true"])');
    let tabpanels = tablist.querySelectorAll('.pdp-tabcontent');

    tablist.addEventListener('keydown', function(e) {
      switch(e.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();   // prevent page scroll
          selectPreviousTab(tablist, tabpanels, tabs);
          break;
          
        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();  // prevent page scroll
          selectNextTab(tablist, tabpanels, tabs);
          break;
          
        case 'Home':
          e.preventDefault();  // prevent page scroll
          selectFirstTab(tablist, tabpanels, tabs);
          break;
          
        case 'End':
          e.preventDefault();  // prevent page scroll
          selectLastTab(tablist, tabpanels, tabs);
          break;
      }
    });
    // Activate tabs when they are clicked (also handles Enter and Space keys)
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function(e) {
        const nextTabIndex = Array.prototype.slice.call(tabs).indexOf(e.target);
        selectTab(nextTabIndex, tabpanels, tabs);
      });
    });
  });
  

  function selectPreviousTab(tablist, tabpanels, tabs) {
    var activeTab = tablist.querySelector('.pdp-tablinks[aria-selected="true"]');
    var activeTabIndex = Array.prototype.slice.call(tabs).indexOf(activeTab);
    
    // Select the previous tab, wrapping to last tab if needed
    if(activeTabIndex > 0) {
      selectTab(activeTabIndex - 1, tabpanels, tabs);
    } else {
      selectTab(tabs.length - 1, tabpanels, tabs);
    }
  }

  function selectNextTab(tablist, tabpanels, tabs) {
    var activeTab = tablist.querySelector('.pdp-tablinks[aria-selected="true"]');
    var activeTabIndex = Array.prototype.slice.call(tabs).indexOf(activeTab);
    
    // Select the previous tab, wrapping to first tab if needed
    if(activeTabIndex < tabs.length - 1) {
      selectTab(activeTabIndex + 1, tabpanels, tabs);
    } else {
      selectTab(0, tabpanels, tabs);
    }
  }

  function selectFirstTab(tablist, tabpanels, tabs) {
    selectTab(0, tabpanels, tabs);
  }

  function selectLastTab(tablist, tabpanels, tabs) {
    selectTab(tabs.length - 1, tabpanels, tabs);
  }

  function selectTab(index, tabpanels, tabs) {
    // Deactivate all tabs
    tabs.forEach(function(tab) {
      tab.setAttribute('aria-selected', false);
      tab.setAttribute('tabindex', -1);
    });
    
    // Activate only the requested tab, and set focus to it
    tabs[index].setAttribute('aria-selected', true);
    tabs[index].setAttribute('tabindex', 0);
    tabs[index].focus();   
    // Hide all tabpanels
    tabpanels.forEach(function(tabpanel) {
      tabpanel.classList.remove('is-visible');
    });
    
    // Show only the tabpanel for the requested tab
    var nextTabpanel = tabpanels[index];
    nextTabpanel.classList.add('is-visible');
  }

  setTimeout(() => {
    function stripAllTabindex(root) {
      if (!root) return;
      if (root.hasAttribute('tabindex')) root.removeAttribute('tabindex');
      root.querySelectorAll('[tabindex]').forEach(el => el.removeAttribute('tabindex'));
    }
    function initRebuyTabindexCleanup() {
      const container = document.getElementById('Block--upsell');
      if (!container) return;

      // Initial pass
      stripAllTabindex(container);

      // Keep it clean as the widget updates
      const mo = new MutationObserver((mutations) => {
        // If anything is added or any tabindex attribute changes, strip again
        let needsStrip = false;
        for (const m of mutations) {
          if (m.type === 'childList' && (m.addedNodes && m.addedNodes.length)) {
            needsStrip = true;
            // Also proactively clear tabindex on added subtrees
            m.addedNodes.forEach(node => {
              if (node.nodeType === 1) stripAllTabindex(node);
            });
          }
          if (m.type === 'attributes' && m.attributeName === 'tabindex') {
            needsStrip = true;
            stripAllTabindex(m.target);
          }
        }
        if (needsStrip) stripAllTabindex(container);
      });

      mo.observe(container, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['tabindex']
      });
    }
    initRebuyTabindexCleanup();
  }, 1000);
})
